<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div class="d-flex flex-column p-3">
      <!-- Loading -->
      <div
        class="d-flex justify-content-center w-100"
        style="margin-top: 110px"
        v-if="loadingTable"
      >
        <loading />
      </div>

      <!-- DataTable con botones -->
      <div class="d-flex flex-row flex-wrap justify-content-start mb-2" v-else>
        <!-- Botones -->
        <div style="w-100">
          <div
            class="d-flex"
            style="position: absolute"
            :style="[zIndexModal && { 'z-index': '0' }]"
          >
            <filtro-bookings-por-confirmar />
            <informacion-general-modal
              :data="dataInformacionGeneral"
              :dataVer="dataVer"
              :load="load"
            />
          </div>
        </div>

        <!-- Data Table -->
        <data-table
          customHeaders
          :headers="headers"
          :data="dataAux"
          :acciones="acciones"
          :max="8"
          paginacion
          buscar
          idtabla="ver_mis_booking_por_confirmar"
          :seleccionar="obtenerFilaSeleccionada"
          numerador
          exportarExcel
        />
      </div>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapState } from "vuex";

// Componentes
import DataTable from "../../../components/common/DataTable";
import Loading from "../../common/loading";
import FiltroBookingsPorConfirmar from "../../filtros/lineas/booking/FiltroBookingsPorConfirmar";
import InformacionGeneralModal from "../../modals/lineas/booking/bookings_por_confirmar/InformacionGeneralModal";

import {
  getBookingsPorConfirmar,
  cancelarBookingPorConfirmar,
  verBookingItineraries,
  sendEmailsContactosClientesPorBookingId,
} from "../../../constants/lineas";

export default {
  props: ["data"],
  computed: {
    ...mapState(["loading", "loadingTable", "zIndexModal"]),
  },
  data() {
    return {
      headers: [
        { title: "ID", width: "35px" },
        { title: "Semana", width: "15px" },
        { title: "Cliente", width: "35px" },
        { title: "Shipper", width: "35px" },
        { title: "Naviera", width: "40px" },
        { title: "Nave", width: "50px" },
        { title: "Consignatario", width: "10px" },
        { title: "POD", width: "60px" },
        { title: "Cantidad", width: "15px" },
        { title: "Producto", width: "40px" },
        { title: "Acciones", width: "20px" },
      ],
      acciones: [],
      dataAux: this.data,
      dataInformacionGeneral: [],
      dataVer: [],
      load: false,
    };
  },
  components: {
    DataTable,
    FiltroBookingsPorConfirmar,
    Loading,
    InformacionGeneralModal,
  },
  methods: {
    ...mapActions(["ActionSetLoadingTable"]),
    ...mapActions("lineas", [
      "actionSetVisibleModalInformacionGeneral",
      "actionSetDatatableBookingsPorConfirmar",
    ]),

    async generarBotonesAcciones() {
      let me = this;

      await me.dataAux.map((item, index) => {
        let id_estado = item.data_complementaria.id_estado;
        if (
          id_estado == 1 ||
          id_estado == 2 ||
          id_estado == 3 ||
          id_estado == 5
        ) {
          me.acciones.push([
            {
              icon: "fa fa-search",
              title: "Ver Booking",
              id: index,
            },
            {
              icon: "far fa-envelope",
              title: "Enviar Booking a email",
              id: index,
            },
            {
              icon: "fa fa-times text-danger",
              title: "Eliminar",
              id: index,
            },
          ]);
        } else if (id_estado == 4) {
          me.acciones.push([
            {
              icon: "fa fa-search",
              title: "Ver Booking",
              id: index,
            },
            {
              icon: "far fa-envelope",
              title: "Enviar Booking a email",
              id: index,
            },
            {
              icon: "fas fa-redo text-danger girarObjeto",
              title: "Esperando respuesta de confirmación de Booking",
              id: index,
            },
          ]);
        } else if (id_estado == 6) {
          me.acciones.push([
            {
              icon: "fa fa-search",
              title: "Ver Booking",
              id: index,
            },
            {
              icon: "fa fa-envelope",
              title: "Enviar Booking a Mail",
              id: index,
            },
            {
              icon: "fas fa-redo text-success girarObjeto",
              title: "Esperando numero de Booking",
              id: index,
            },
          ]);
        }
      });

      me.ActionSetLoadingTable(false);
    },
    async obtenerFilaSeleccionada(fila) {
      let data_fila = this.data[fila.id];
      let id_reserva = data_fila.data[0];
      let nombre_cliente = data_fila.data[2];
      let id = data_fila.data[0];
      let booking_itinerary_id =  data_fila.data_complementaria.booking_itinerary_id;
      let id_booking = data_fila.data_complementaria.booking_id;
      let cantidadModel = data_fila.data[8];

      if (fila.accion == "Ver Booking") {
        this.load = true;
        this.actionSetVisibleModalInformacionGeneral(true);
        this.dataInformacionGeneral = data_fila;
        await this.cargarVerBookingItineraries({
          id_booking,
          booking_itinerary_id,
        });

        this.load = false;
      } else if (fila.accion == "Eliminar") {
        this.$vToastify
          .prompt(
            `¿Desea eliminar el Booking, ID: ${id_reserva} de ${nombre_cliente} ?`
          )
          .then(
            (respuesta) =>
              respuesta &&
              this.eliminarBookingPorConfirmar(
                id,
                booking_itinerary_id,
                cantidadModel
              )
          );
      } else if (fila.accion == "Enviar Booking a email") {

        const response = await this.$vToastify.prompt({ body: `¿Desea enviar Booking a Email?`, answers: { Sí: true, No: false }}) ;
        if( !response ) return ;

        try {
          this.$vToastify.loader("Realizando Solicitud...");
          await sendEmailsContactosClientesPorBookingId( id_booking , "porConfirmar", booking_itinerary_id ) ;

          this.$vToastify.stopLoader();
          this.$vToastify.success("Booking enviado a emails correctamente", "¡Realizado!" );

        } catch (error) {
          this.$vToastify.stopLoader();
          this.$vToastify.error( "Error al enviar booking por email, intente más tarde", "¡Error!" );
        }

      }
    },
    async cargarVerBookingItineraries(form) {
      const data = await verBookingItineraries(form);
      this.dataVer = data;
    },

    async eliminarBookingPorConfirmar(id, booking_itinerary_id, cantidadModel) {

      let sql = await cancelarBookingPorConfirmar({
        id,
        booking_itinerary_id,
        cantidadModel,
      });

      if (!sql.error) {
        // Consulta nuevamente a la API para obtener la nueva data
        let dataCancelPorConfirmarDB = await getBookingsPorConfirmar();

        // Actualizar los datos del dataTable
        this.actionSetDatatableBookingsPorConfirmar(
          dataCancelPorConfirmarDB.data_table
        );
        this.generarBotonesAcciones();

        this.dataAux = dataCancelPorConfirmarDB.data_table;

        this.$vToastify.success(
          "Booking Por Confirmar eliminado correctamente",
          "¡Realizado!"
        );
      } else {
        console.log("Error");
      }
    },
  },
  created() {
    setTimeout(() => {
      this.generarBotonesAcciones();
    }, 400);
  },
  watch: {
    data: function (_new) {
      let me = this;

      // Si watch detecta un cambio en la variable dataDatatableFilialesFiltrada la cual es un state de vuex, esta asignada el nuevo
      // valor a la variable data
      if (_new) {
        me.dataAux = _new;
        this.generarBotonesAcciones();
      }
    },
  },
};
</script>

<style></style>
